export class DataQuality {
    ContactEmailAddress: string;
    ContactTelephoneNumber: string;
}



// WEBPACK FOOTER //
// ./src/app/models/data-quality.ts